import ServiceBase from "./ServiceBase";

class CourseService extends ServiceBase {
  async checkLimit(courseId) {
    let data = await this.http.get("/api/app/course/limit/visit/" + courseId);
    return new Promise(resolve => {
      if (data.limit == 0) {
        resolve();
      } else {
        this.vue.$warning("您已被限制访问，请联系管理员");
      }
    });
  }

  checkLiveState(course_type, period, type = 1) {
    if (course_type == 2 || course_type == 3 || course_type == 15) {
      if (period.play_type == 3 || period.play_type == 5) {
        return false;
      }
    }
    if (course_type == 16) {
      if (type == 1) {
        if (period.play_type == 3 || period.play_type == 5) {
          return false;
        }
      } else if (type == 2) {
        if (
          period.min_class == 0 ||
          period.min_play_type == 3 ||
          period.min_play_type == 5
        ) {
          return false;
        }
      }
    }
    return true;
  }

  async watchVideo(period, course_type, course_id, type) {
    if (!this.checkLiveState(course_type, period, type)) {
      return;
    }
    if (
      course_type == 2 ||
      course_type == 3 ||
      course_type == 15 ||
      course_type == 16
    ) {
      let params = {
        id: period.id,
        title: period.periods_title,
        period_id: period.period_id,
        type,
      };
      this.vue.$livePlay(course_id, course_type, params);
    } else if (course_type == 5 || course_type == 8) {
      this.vue.$router.push({
        name: "Video",
        query: {
          course_id: course_id,
          period_id: period.id,
          video_id: period.video_id,
          course_type: course_type,
        },
      });
      // const route = this.vue.$router.resolve({
      //   name: "Video",
      //   query: {
      //     course_id: course_id,
      //     period_id: period.id,
      //     video_id: period.video_id,
      //     course_type: course_type,
      //   },
      // });

      // window.open(route.href, '_blank');
    }
  }

  async getPeriodContent(period, system_course_id) {
    let params = {};
    if (system_course_id) {
      params.system_course_id = system_course_id;
    }
    return await this.http.get("/api/app/chapterInfo/" + period.id, params);
  }

  async openPeriodFile(period, id, index, system_course_id) {
    let params = {};
    if (system_course_id) {
      params.system_course_id = system_course_id;
    }
    let data = await this.http.get(
      "/api/app/chapterDatum/" + id + "/" + index,
      params,
    );
    window.open(data.file_url);
  }

  checkBuyValid(course) {
    if (course.valid_end_time === undefined || course.valid_end_time === -1) {
      return false;
    }
    if (course.valid_end_time === 0) {
      return true;
    }
    return course.valid_end_time * 1000 >= new Date().getTime();
  }
}

export default () => {
  return new CourseService();
};
